import { Loader } from 'lucide-react'
import { Button, SearchableDropdown } from '@frontend/ui'
import {
  useAppDispatch,
  useAppSelector,
  useReportingTeams
} from '@frontend/react'
import { selectReportingTeamId } from '@frontend/core/lib/domains/reporting'
import { switchReportingTeam } from '../lib/reporting-actions'

export function ReportingTeamSwitcher() {
  const dispatch = useAppDispatch()
  const teamId = useAppSelector(selectReportingTeamId) || ''
  const { options, isLoading, isFetching } = useReportingTeams()

  // Render a placeholder in loading states (initial fetch, region-switch
  // invalidation) so the nav layout doesn't collapse.
  if (isLoading || (isFetching && options.length === 0)) {
    return (
      <Button
        variant='outline'
        disabled
        className='w-44 justify-start gap-2 bg-transparent'
      >
        <Loader className='h-4 w-4 animate-spin opacity-50' />
        <span className='text-muted-foreground truncate text-sm'>
          Loading teams…
        </span>
      </Button>
    )
  }

  if (options.length === 0) return null

  const handleTeamChange = (value: string | number | string[]) => {
    dispatch(switchReportingTeam(value.toString() || null))
  }

  return (
    <SearchableDropdown
      options={options}
      value={teamId}
      onSelect={handleTeamChange}
      placeholder='Select team...'
      searchPlaceholder='Search teams...'
      className='w-44'
      clearButton={false}
    />
  )
}
